import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Loader from '../../Loader';

const propTypes = {
  snapshots: PropTypes.array
};

const defaultProps = {
  snapshots: []
};

class SnapshotPage extends React.Component {

  render() {

    const { snapshots, key, className, scrollPosition, ...props } = this.props;
    const loaderProps = {style: {height: 'auto'}, dark: true};
    delete props.useIntersectionObserver;

    let content;
    if(_.size(snapshots) > 0) {
      content = snapshots.map( (snapshot) => {
        return (
          <div className="member-snapshot-item-wrap col-md-3 col-sm-4 col-6" key={snapshot.snapshots_url}>
            <div className="member-snapshot-item">
              <Link to={snapshot.snapshots_url} target="_blank" className="snapshot-result">
                <div className="snapshot-inner-wrap">
                  <div className="snapshot-hover-info">
                    <div className="u-font-foundation-light abs-center hover-text">View <br />Snapshot</div>
                  </div>
                  <LazyLoadImage
                    alt={'test'}
                    height={144}
                    src={snapshot.thumbnail_url.replace('http://', 'https://')} // use normal <img> attributes as props
                    placeholder={<Loader ref="loader" {...loaderProps} fill />}
                    scrollPosition={scrollPosition}
                  />
                </div>
              </Link>
            </div>
          </div>
        )
      });
    } else {
      content = (
        <span>&nbsp;</span>
      );
    }

    return (
      <div className={className + ' member-snapshot-item-wrap'} {...props}>
        <div className="row no-gutters">
          {content}
        </div>
      </div>
    );

  }
}

SnapshotPage.defaultProps = defaultProps;
SnapshotPage.propTypes = propTypes;

export default SnapshotPage;
